import React from 'react';
import loadable from '@loadable/component';
import { liveHowItWorksOnEnterSaga } from 'features/Videos/sagas/live.onenter.saga';

const LiveFeatures = loadable(() => import('features/LiveSell/LiveFeatures'));

export default (store, client) => ({
  path: '/live',

  indexRoute: {
    onEnter: (nextState, replace) => replace('/live/features'),
  },

  childRoutes: [
    {
      path: 'features',
      component: props => <LiveFeatures {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveHowItWorksOnEnterSaga, client, nextState, replaceState, 'features')
          .toPromise()
          .then(cb),
    },
  ],
});
